import Configuration from './Configuration'

export default Configuration
